import { useEffect, useState } from 'react'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import api from '../helpers/apiRequester'
import { getLoginUrl } from '../helpers/authConfig'
import { CronScrapersView } from '../components/views/cronScrapersView'

function CronScrapers() {
    const navigate = useNavigate()
    const [dataReady, setDataReady] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!dataReady && !loading) {
            Loading.circle('Loading...')
            setLoading(true)
            checkAuth()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataReady, loading])

    // Mirrors the pattern in containers/users.tsx — calling any endpoint that
    // re-checks `isAdminUser` is enough to gate the page. We use
    // `/credit-scrape-introducers` so the response also primes the view if it
    // succeeds (the view will refetch but the credential is already warm).
    const checkAuth = async () => {
        try {
            await api({ url: 'credit-scrape-introducers', data: {} })
            setDataReady(true)
            Loading.remove()
        } catch (error: any) {
            console.log(error)
            Loading.remove()
            if (error?.response?.status === 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else if (error?.response?.status === 403) {
                Report.failure(
                    'Access Denied',
                    'The Credit Scrapers page is restricted to Sentinel admin users only.',
                    'Return to Dashboard',
                    () => {
                        navigate('/home')
                    }
                )
            } else {
                Report.failure('Access Denied', 'You do not have permission to view this page.', 'Okay', () => {
                    navigate('/home')
                })
            }
        }
    }

    return (
        <div className="cronScrapers">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Admin"
                        title="Credit Scrapers"
                        intro="Trigger and monitor the scheduled credit-report scrapers for each introducer."
                    />
                    {dataReady ? <CronScrapersView /> : <></>}
                </Page>
            </MainView>
        </div>
    )
}

export default CronScrapers
